import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Sticky from 'Components/Sticky/index';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as MinusIcon } from 'Icons/theme-minus.svg';
import { ReactComponent as DownloadIcon } from "Icons/download-white.svg";
import { connect } from 'react-redux';
import { Table, Button } from "reactstrap";
import {
    GET_WINNING_TRANSPORTERS,
    SAVE_WINNING_TRANSPORTERS,
    DOWNLOAD_EVENT_DETAILS_TEMPLATE,
    DELETE_TRANSPORTER_IN_WINNIG_PAGE
} from 'Constants/actionConstants';
import { downloadUrl } from "Utils/index";
import ConfirmationPopup from './confirmationPopup';
import ActionLoader from 'Components/ActionLoader/index';

class WinningTransporters extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            isLoader: true,
            rfqIds: [],
            openPopup: false
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_WINNING_TRANSPORTERS,
            data: {}
        });
        if (this.setTimer) {
			clearTimeout(this.setTimer);
		}
        this.getWinningTransporters();
    }

    getWinningTransporters = () => {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_WINNING_TRANSPORTERS,
            params: {
                eventId: match.params.eventId
            },
            // onSuccess: () => {
            //     this.setStatusTimer();
            // }
        });
    }

    setStatusTimer = () => {
		if (this.unmounted) { return };
		if (this.setTimer) {
			clearTimeout(this.setTimer);
		}
		this.setTimer = setTimeout(() => {
			this.getWinningTransporters();
		}, 10000);

	}

    componentWillUnmount() {
		this.unmounted = true;
		if (this.setTimer) {
			clearTimeout(this.seekerBidsTimer);
		}
	}

    getStatus = (id) => {
        const statusObj = {
            color: '',
            value: ''
        }
        if(id === 2) {
            statusObj.color = '#FF9900';
            statusObj.value = 'Yet To start';
        } else if(id === 3) {
            statusObj.color = '#OCO6f7';
            statusObj.value = 'In Progress';
        } else if(id === 5) {
            statusObj.color = '#78A55A';
            statusObj.value = 'Completed';
        } else if(id === 6 || id === 99) {
            statusObj.color = 'red';
            statusObj.value = 'Canceled';
        }
        return statusObj;
    }

    getSumOfWinningVolume = (rfq, id) => {
        const { trips } = rfq;
        let sumOfPrice = 0;
        (trips || []).map(trip => {
            const price = ((trip.bid || []).find(bid => bid.transporter_id === id) || {}).sum_product_value;
            if(!sumOfPrice) {
                sumOfPrice = price;
            }
        })
        return sumOfPrice;
    } 

    getTransporterPrice = (bid, id) => {
        const tPrice = ((bid || []).find(bid => bid.transporter_id === id) || {}).winning_volume || 0;
        return tPrice;
    }

    onClickDownload = () => {
        const { dispatch, match } = this.props;
        const branchLocalName = localStorage.getItem('branchDetail');
        const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
    
        dispatch({
            type: DOWNLOAD_EVENT_DETAILS_TEMPLATE,
            data: {
                type: 4,
                rfqType: 1,
                eventId: match.params.eventId,
                branchId: name.branch_id,
            },
            onSuccess: (data) => {
                downloadUrl(data.link);
            }
        })
    }

    expandCollapse = (id) => {
        const { rfqIds } = this.state;
        const rfqIndex = rfqIds.findIndex(el => el === id);
        if(rfqIndex > -1) {
            rfqIds.splice(rfqIndex, 1);
        } else {
            rfqIds.push(id);
        }
        this.setState({
            rfqIds
        })
    }

    onDeleteTransporter = (rfq, transporterId) => {
        this.setState({
            openPopup: true,
            deleteData: {
                rfqId: rfq.rfq_id,
                transporterId
            }
        })
    }

    onCancel = () => {
        this.setState({
            openPopup: false,
            deleteData: {}
        })
    }

    saveDeleteTransporter = () => {
        const { dispatch } = this.props;
        const { deleteData } = this.state;
        dispatch({
            type: DELETE_TRANSPORTER_IN_WINNIG_PAGE,
            data: deleteData,
            onSuccess: () => {
                this.getWinningTransporters(); 
            }
        });
        this.onCancel();
    }

    goBack = () => {
        const { history } = this.props;
        history.push('/eventManagement');
    }

    render() {
        const { winning_order, winning_volume_list } = this.props.winningTransporters;
        const { rfqIds, openPopup } = this.state;

        return(
            <Sticky>
                {this.props.loader && <ActionLoader fixed={true} />}
                <div
                className="pv-20 ph-20 winning-transporters"
                style={{ backgroundColor: "#e3e9ff", 'minHeight' : "760px" }}
                >
                {/* {isLoader && <ActionLoader fixed={true} />} */}
                    <div className='flex flex-between'>
                        <div className='flex fBold'>
                            {/* <Link
                                className="ht-30 theme-color fs-20 flex flex-middle wt-max-content mb-10 mt-5 fBold"
                                to={`/eventManagement`}
                            > */}
                                <div className='fBold theme-color fs-20 curP' onClick={this.goBack}>{'< Back'}</div>
                            {/* </Link> */}
                            <div className='fs-20 ml-10'>{this.props.match.params.eventId} (Winning Transporters)</div>
                        </div>
                        <Button className={"download-button"} onClick={() => this.onClickDownload(4)}>
                            <span className="flex flex-around pr-20 pl-20 fBold fs-16">
                            <DownloadIcon width="16" height="16" />
                                Download
                            </span>
                        </Button>
                    </div>
                    <div className={'fBold mb-10'} style={{'color': '#78A55A'}}>* All Business Volumes are in MT</div>
                    <Table className="upload-rfq-table status-table-height" striped responsive>
                        <thead>
                            <tr>
                                <th className="upload-th" colSpan={2}></th>
                                {(winning_order || []).map(wOrder => (<th className="upload-th">{wOrder.transporter_name}</th>))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td className="upload-td-th" colSpan={2}> <div className='fBold fs-20'>Overall</div> </td>
                            {(winning_order || []).map((wOrder, wOrderIndex) => (<td className="upload-td-th" style={{"color": wOrderIndex === 0 ? '#0C06F7' : ''}}><div className='fBold fs-20'>{wOrder.sum_winning_volume}</div></td>))}
                            </tr>
                            <tr>
                                <td colSpan={2} className={'pv-10'}> <div className='fBold fs-20'></div> </td>
                                {(winning_order || []).map(wOrder => (<td><div className='fBold fs-20'>{}</div></td>))}
                            </tr>
                            {(winning_volume_list || []).map((rfq, rfqIndex) => {
                                const cFlag = rfqIds.includes(rfq.rfq_id);
                                return (<>
                                <tr>
                                    <td className={`upload-td-th ${cFlag ? 'event-header-form' : ''}`}>{rfqIds.includes(rfq.rfq_id) ? <MinusIcon  className={'mr-5 curP wt-15 ht-15'} onClick={() => this.expandCollapse(rfq.rfq_id)}/> : <PlusIcon  className={'bg-theme mr-5 curP'} onClick={() => this.expandCollapse(rfq.rfq_id)}/>}{rfq.rfq_name}</td>
                                    <td className={`upload-td-th ${cFlag ? 'event-header-form' : ''}`} style={{'color': (this.getStatus(rfq.status) || {}).color}}>{rfq.status_name}</td>
                                    {(winning_order || []).map(wOrder => (<td className={`upload-td-th ${cFlag ? 'event-header-form' : ''}`} style={{'color': (this.getStatus(rfq.status) || {}).color}}>{this.getSumOfWinningVolume(rfq, wOrder.transporter_id) || <span className='table-text-color'>{0} {rfq.status === 2 && <span className='error-color fBold fs-20 curP fRight' onClick={() => this.onDeleteTransporter(rfq, wOrder.transporter_id)}>X</span>}</span>}</td>))}
                                </tr>
                                {rfqIds.includes(rfq.rfq_id) && (rfq.trips || []).map((trip, tripIndex) => 
                                    (<tr>
                                    <td className="upload-td-th trip-details">{trip.from} - {trip.to}</td>
                                    <td className="upload-td-th trip-details" style={{'color': (this.getStatus(rfq.status) || {}).color}}>{rfq.status_name}</td>
                                    {(winning_order || []).map(wOrder => (<td className="upload-td-th trip-details" style={{'color': (this.getStatus(rfq.status) || {}).color}}>{this.getTransporterPrice((trip.bid || []), wOrder.transporter_id) || 0}</td>))}
                                </tr>))}
                            </>)})}
                        </tbody>
                    </Table>
                    {openPopup && <ConfirmationPopup text={'Are you Sure you want to Remove ?'} onCancel={this.onCancel} onSave={this.saveDeleteTransporter}/>}
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
        winningTransporters: contracting.winningTransporters || {},
        loader: contracting.loader || false
    }
}

export default connect(mapStateToProps)(WinningTransporters); 